"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerLevel = void 0;
var TimerLevel;
(function (TimerLevel) {
    TimerLevel["Native"] = "NATIVE";
    TimerLevel["Proprietary"] = "PROPRIETARY";
})(TimerLevel || (exports.TimerLevel = TimerLevel = {}));
